import React from 'react';
import { ChevronRight } from 'lucide-react';

export interface QuickActionItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
}

export const QuickActionItem: React.FC<QuickActionItemProps> = ({
  icon,
  title,
  description,
  onClick,
  disabled = false,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`w-full flex items-center gap-4 py-3 text-left transition-opacity duration-150 active:opacity-70 ${
      disabled ? 'opacity-40 cursor-not-allowed' : ''
    }`}
  >
    <div className="w-9 h-9 rounded-lg bg-white/8 flex items-center justify-center flex-shrink-0 text-white/60">
      {icon}
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-white text-sm font-medium leading-tight">{title}</p>
      <p className="text-white/40 text-xs mt-0.5">{description}</p>
    </div>
    <ChevronRight className="text-white/30 flex-shrink-0" size={16} />
  </button>
);
